export const AddToGroup = "AddToGroup";
export const ConnectionData = "ConnectionData";
export const HangUp = "HangUp";
export const StartCall = "StartCall";
export const AssetUpdated = "AssetUpdated";
export const AssetDeleted = "AssetDeleted";
export const ImageReceived = "ImageReceived";
export const CanvasObject = "CanvasObject";
export const LiveDrawingClose = "liveDrawingClose";
export const RemoteRecording = "RemoteRecording";
export const requestHDImage = "RequestHDImage";
export const chatMessage = "ChatMessage";
export const setOpenTokConnectionId = "SetOpenTokConnectionId";
export const audioTranslationReady = "AudioTranslationReady";
export const audioTranscriptionReady = "AudioTranscriptionReady";
export const audioSubtitleReady = "AudioSubtitleReady";
export const audioTranslationStop = "AudioTranslationStop";
export const setTranslationSubtitles = "SetTranslationSubtitles";
export const setChatTranslation = "SetChatTranslation";
export const setTranslationLanguages = "SetTranslationLanguages";
export const updateTranslationLang = "UpdateTranslationLang";
export const CallNotification = "CallNotification";
export const CallNotificationResponse = "CallNotificationResponse";
export const sendPointer = "SendPointer";
export const showPointer = "ShowPointer";
export const updateMicrophone = "UpdateMicrophone";
export const setMicrophone = "SetMicrophone";
export const updateTranscriptions = "UpdateTranscriptions";
export const updateTranscriptionsLang = "UpdateTranscriptionsLang";
export const setTranscriptions = "SetTranscriptions";
export const setTranscriptionsLang = "SetTranscriptionsLang";
export const setConnectionId = "SetConnectionId";
export const initParticipant = "InitParticipant";
export const addParticipant = "AddParticipant";
export const disconnectParticipant = "DisconnectParticipant";
export const startTranscription = "StartTranscription";
export const startTranslation = "StartTranslation";
export const stopTranslation = "StopTranslation";
export const stopAudioConnector = "StopAudioConnector";
export const deleteChatMessage = "DeleteChatMessage";
export const updateUserName = "UpdateUserName";
export const updateAssistanceState = "UpdateAssistanceState";
export const updateParticipants = "UpdateParticipants";
export const addAssistance = "AddAssistance";
export const addCommentAsset = "AddCommentAsset";
export const deleteCommentAsset = "DeleteCommentAsset";
export const reportUploadProgress = "ReportUploadProgress";
export const receiveUploadProgress = "ReceiveUploadProgress";

export const assistanceClose = "AssistanceClose";
export const assistanceReopen = "AssistanceReopen";
